import SeoHead from "@/Component/Seo/SeoHead";
import CountryCity from "@/Component/CountryCity";
import {
  serverFetchCountryCityPageData,
  serverFetchReviewsList,
  serverFetchThingsToDo,
} from "@/services/server";
import { getCountryFromContext } from "@/utils/getCountryFromRequest";
import {
  isCountryCityPageSuccess,
  normalizeCountryCityPageResponse,
} from "@/utils/countryCityHelpers";
import { renderNotFoundPage } from "@/utils/detailSlug";
import { fetchPageSeo } from "@/utils/pageSeo";

function getPlaceRedirectPath(slug, context) {
  const path = String(context.resolvedUrl || context.req?.url || "").split("?")[0];
  return path.startsWith("/in") ? `/in/place/${slug}` : `/place/${slug}`;
}

export default function DynamicPage({ seo, seoCountry, slug, pageData, initialReviewsList }) {
  const fallbackTitle = pageData?.pageTitle || "Holiday Packages";

  return (
    <>
      <SeoHead
        seo={seo}
        country={seoCountry}
        fallbackTitle={`${fallbackTitle} | Next Holidays`}
      />
      <CountryCity
        slug={slug}
        pageData={pageData}
        initialReviewsList={initialReviewsList}
      />
    </>
  );
}

export async function getServerSideProps(context) {
  const slugParam = context.params?.slug;
  const slug = Array.isArray(slugParam) ? slugParam[0] : slugParam;

  if (!slug) {
    return renderNotFoundPage(context);
  }

  const country = getCountryFromContext(context);
  const seoResult = await fetchPageSeo(context);
  if (seoResult.redirect) return seoResult;

  try {
    const countryCityResponse = await serverFetchCountryCityPageData(slug, country);

    if (isCountryCityPageSuccess(countryCityResponse)) {
      const reviewsResponse = await serverFetchReviewsList(
        { moduleType: "CountryCityPage", slug },
        country
      );

      return {
        props: {
          seo: seoResult.seo,
          seoCountry: seoResult.seoCountry,
          slug,
          pageData: normalizeCountryCityPageResponse(countryCityResponse, slug),
          initialReviewsList: reviewsResponse?.data || null,
        },
      };
    }
  } catch (error) {
    console.error("Country/city page SSR error:", error);
  }

  try {
    const thingsToDoResponse = await serverFetchThingsToDo(slug, country);

    if (String(thingsToDoResponse?.status || "").toLowerCase() === "success") {
      return {
        redirect: {
          destination: getPlaceRedirectPath(slug, context),
          permanent: true,
        },
      };
    }
  } catch (error) {
    console.error("Legacy things-to-do redirect error:", error);
  }

  return renderNotFoundPage(context);
}
